
import React from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { yellow } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    mainContainer : {
        height: 400,
        backgroundImage: "url(https://cdn.pixabay.com/photo/2016/03/26/13/09/cup-of-coffee-1280537_960_720.jpg)",
        color: 'white',
        backgroundSize: 'cover'
    },
    mainItem: {
        padding: theme.spacing(3),
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',

    }
}));

function MainGridItem() {
    const classes = useStyles();
    return (
        <Grid container className={classes.mainContainer}>
            <Grid item className={classes.mainItem} md={6}>
            <Typography component='h2' variant='h4'>
                Sitio Web oficial
            </Typography>
            <Typography variant='body1' paragraph>
                Bienvenidos al sitio oficial de Aldo Echeverría (versión beta), 
                aquí encontrarás más informes sobre las aplicaciones y proyectos de este desarollador web.
                La página oficial está aun en www.aldoecheverria.com, pero pronto se actualizará con esta versión cuando esté en la final.
            </Typography>
            </Grid>
        </Grid>
    )
}

export default MainGridItem
